module.exports = __webpack_public_path__ + "img/clerk_incoming_goods_1.ebf101f0.png";